module.exports = __webpack_public_path__ + "static/box-community.1cd66faa.jpg";